// Corporate policy destinations are centrally owned, not publication overrides.
export const SHARED_POLICIES = Object.freeze({
  privacy: "https://surgezircmedia.com/p/privacy-policy",
  cookies: "https://surgezircmedia.com/p/cookie-policy"
});
